import React from 'react'
import { Grid } from '@mui/material'
import { useStyles } from './DisablePage.styles'
import { ProductInfo, type ProductInfoProps } from './ProductInfo'
import Disable from '../../images/Disable.png'
import { OnboardingHeaderTitleBar } from '../OnboardingHeaderTitleBar'
import { CloudTypeEnum } from '../../types'

export type DisablePageProps = {
  productInfo: ProductInfoProps
  header?: string
  showHeader?: boolean
  image?: string
}

export const DisablePage: React.FC<DisablePageProps> = ({
  productInfo,
  header,
  showHeader = true,
  image = Disable,
}) => {
  const { classes } = useStyles({})
  return (
    <>
      {header && showHeader && (
        <div className={classes.header}>
          <OnboardingHeaderTitleBar
            title={header}
            cloudType={CloudTypeEnum.AWS}
          />
        </div>
      )}
      <div className={classes.container}>
        <Grid
          container
          className={classes.root}
          data-testid="disable-page"
          width="100%"
        >
          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
            }}
          >
            <img
              src={image}
              alt="Stock-Image"
              className={classes.disableImage}
              data-testid="stock-image"
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 8,
              md: 8,
              lg: 8,
            }}
          >
            <ProductInfo {...productInfo} />
          </Grid>
        </Grid>
      </div>
    </>
  )
}
